<template>
    <v-dialog v-model="show" persistent max-width="350">
      <v-card>
        <v-app-bar flat :color="color" class="white--text" dense>
          <v-toolbar-title>{{title}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-icon class="white--text" @click="close(false)">mdi-close</v-icon>
        </v-app-bar>
        <v-card-text class="pt-10">
          <div class="text-subtitle-1 font-weight-medium">
          <slot></slot>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions >
          <v-spacer></v-spacer>
          <v-btn text :color="color" @click="close(true)">Aceptar</v-btn>
          <v-btn text :color="color" @click="close(false)">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: {
        show: {
          type: Boolean,
          required: true
        },
        color: {
          type: String,
          default: "primary"
        },
        title: {
          type: String,
          default: 'Confirmar'
        }
    },
    methods: {
      close(value) {
        //this.show = false;
        this.$emit("selected", value);
      }
    }
}
</script>
